import { getCookie } from '../core/utils.js';

var code = '',
  ccode = '';

export function checkChannelParams() {
  var channels = document.querySelectorAll('.cta-channel');
  if (channels.length > 0) { channelParams(channels); }
}

function channelParams(channels) {
  channels.forEach(function (channel) {
    var temp = channel.getAttribute('href');
    var suf = '';
    switch (true) {
      case temp.includes('talenta.co'):
        suf = 'T6U';
        break;
      case temp.includes('jurnal.id'):
        suf = 'J1U';
        break;
      case temp.includes('qontak.com'):
        suf = 'Q3Q';
        break;
      case temp.includes('klikpajak.id'):
        suf = 'K8Q';
        break;
      case temp.includes('mekarisign.com'):
        suf = 'E5Q';
        break;
      case temp.includes('expense.mekari.com'):
        suf = 'X6O';
        break;
      case temp.includes('officeless.mekari.com'):
        suf = 'O3N';
        break;
      case temp.includes('desty.mekari.com'):
        suf = 'D6O';
        break;
      case temp.includes('officeless.mekari.com'):
        suf = 'O7O';
        break;
      // case temp.includes('univ.mekari.com'):  
      //   suf = 'U4C';  
      //   break; 
      case temp.includes('mekari.com'):
        suf = 'M1V';
        break;
    }

    code = getCookie('waba_code') ?? '';
    ccode = getCookie('wabac_code') ?? '';

    var pageID = document.querySelector('#page_id').value ?? '';
    if (pageID) {
      temp = temp.replace('{{channel}}', suf + code + ccode + '-' + pageID);
      temp = temp.replace('%7B%channel%7D%7D', suf + code + ccode + '-' + pageID);
    } else {
      temp = temp.replace('{{channel}}', suf + code + ccode);
      temp = temp.replace('%7B%channel%7D%7D', suf + code + ccode);
    }

    channel.href = temp;
  });
}